window.addEventListener("DOMContentLoaded", function() {
  const filters = document.querySelectorAll('.c-aggregator--filter');
  if (filters.length) {
    aggregatorfilterInit(filters);
  }
});

function aggregatorfilterInit(filters) {
  for (let i = 0; i < filters.length; i++) {
    let filter = filters[i];
    let items = filter.querySelectorAll('li');
    for (let j = 0; j < items.length; j++) {
      let item = items[j];
      item.addEventListener('click', function (e) { // jshint ignore:line
        let element = e.target;
        if (element.dataset.category == '') {
          // Filter "ALL"
          if (!element.classList.contains('active')) {
            aggregatorfilterReset(filter);
            element.classList.add('active');
          }
        } else {
          // Other Filters
          if (element.classList.contains('active')) {
            aggregatorfilterReset(filter);
            filter.querySelector('li[data-category=""]').classList.add('active');
          } else {
            aggregatorfilterReset(filter);
            element.classList.add('active');
          }
        }
        aggregatorfilterAddCategoryLink(element.dataset.category);
        aggregatorfilterRender(document);
      });
    }
    aggregatorfilterRender(filter);
  }
}

function aggregatorfilterReset(element) {
  let off = element.querySelectorAll('.c-aggregator--filter li');
  for (let i = 0; i < off.length; i++) {
    off[i].classList.remove('active');
  }
}

function aggregatorfilterRender(element) {
  const vehicles = element.querySelectorAll('.c-composition-teaserbox-vehicle_container, .c-composition-teaserbox-text_container');

  let vehicle = null;
  let filter_category = [];
  let filter_category_nodes = element.querySelectorAll('.c-aggregator--filter li.active');

  if (filter_category_nodes[0].dataset.category != '') {
    for(let i = 0; i < vehicles.length; i++) {
      vehicle = vehicles[i];
      $(vehicle.parentNode.parentNode).hide();
      if (vehicle.classList.contains('aos-animate')) {
        vehicle.classList.remove('aos-animate');
      }
    }

    for (let i = 0; i < filter_category_nodes.length; i++) {
      filter_category[i] = filter_category_nodes[i].dataset.category;
    }

    let filter_class = '.' + filter_category.join(', .');
    let vehicles_found = element.querySelectorAll(
      '.c-composition-teaserbox-vehicle_container'+ filter_class + ', .c-composition-teaserbox-text_container' + filter_class
    );

    for(let i = 0; i < vehicles_found.length; i++) {
      var vehicle_found = vehicles_found[i];
      $(vehicle_found.parentNode.parentNode).show();
      if (!vehicle_found.classList.contains('aos-animate')) {
        vehicle_found.classList.add('aos-animate');
      }
    }
  } else {
    for(let i = 0; i < vehicles.length; i++) {
      vehicle = vehicles[i];
      $(vehicle.parentNode.parentNode).show();
      if (!vehicle.classList.contains('aos-animate')) {
        vehicle.classList.add('aos-animate');
      }
    }
  }
}

function aggregatorfilterAddCategoryLink(category) {
  var elements = window.document.querySelectorAll('.c-composition-teaserbox-vehicle_container > .button-container > .button-mainlink > .c-link a');
  const pattern = /\?category=[^\s]+$/g;
  for (let i = 0; i < elements.length; i++) {
    var element = elements[i];
    var href = element.href.replace(pattern, '');
    console.log(href);
    element.href = href + '?category=' + category;
  }
}
